import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

// Gates a feature behind the org's active plan. While entitlements load, children render
// (avoids a flash); once loaded, a locked feature shows an upgrade prompt instead.
export default function UpgradeGate({ feature, title, children }) {
  const { entitlements } = useAuth();
  const navigate = useNavigate();
  const features = entitlements?.features || [];

  if (entitlements && !features.includes(feature)) {
    return (
      <div className="flex min-h-[55vh] flex-col items-center justify-center rounded-xl border border-slate-800 bg-[#111827] p-10 text-center" data-testid="upgrade-gate">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-600/15 text-blue-400">
          <Lock className="h-7 w-7" />
        </span>
        <h2 className="mt-5 font-display text-xl font-bold text-white">{title || "Upgrade to unlock"}</h2>
        <p className="mt-2 max-w-md text-sm text-slate-400">
          This feature isn't included in your current plan. Upgrade to unlock it for your whole team.
        </p>
        <Button onClick={() => navigate("/portal/billing")} data-testid="upgrade-gate-cta"
          className="mt-6 gap-2 rounded-full bg-blue-600 text-white hover:bg-blue-500">
          View plans
        </Button>
      </div>
    );
  }
  return children;
}
